import { Row, Col, Breadcrumb } from "react-bootstrap";
import { ILicenceActionDetails } from "../../../api/ILicensingAction";
import { ILicenceProfile } from "../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  licenceActionDetails: ILicenceActionDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  licenceActionDetails,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions`}
        >
          Authorisation Versions
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions/${licenceActionDetails.licenceid}`}
        >
          {licenceActionDetails.licence_regno}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{licenceActionDetails.code}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
